import FrequentTravelerSurchargeModal from './FrequentTravelerSurchargeModal';

export default FrequentTravelerSurchargeModal;
